export default __webpack_public_path__ + "static/media/lotsaShrimps.76bf416a.jpg";